import { SkyMessageBar, SkyButton } from "@skypointcloud/skypoint-ui";
import { X } from "lucide-react";
import { Styles } from "./successAndErrorMessage.style";
import { useEffect, useState } from "react";
import useIsMounted from "ismounted";
import { notifyMessage } from "../../common/notifyMessage";

interface PropsInterface {
  notificationMessage?: string;
  styles?: React.CSSProperties;
  successClassName?: string;
  failureClassName?: string;
  warningClassName?: string;
  closeButtonPresent?: boolean;
  onDismiss?: (type: string) => void;
}

const SuccessAndErrorMessage = (props: PropsInterface) => {
  const { notificationMessage, styles, successClassName, failureClassName, warningClassName } =
    props;
  const [onClose, setOnClose] = useState<boolean>();
  const isMounted = useIsMounted();
  const handleClose = () => {
    setOnClose(false);
  };
  useEffect(() => {
    setOnClose(true);
  }, [onClose]);

  useEffect(() => {
    if (isMounted) {
      if (!notificationMessage) {
        notifyMessage(successClassName || "successMessage", 0);
        notifyMessage(failureClassName || "errorMessage", 0);
        notifyMessage(warningClassName || "warningMessage", 0);
      }
    }
  }, [notificationMessage]);

  return (
    <>
      {onClose && (
        <div
          id={successClassName ? successClassName : "successMessage"}
          style={{ ...Styles.messageBar, ...styles }}
        >
          <div
            className={successClassName ? successClassName : "successMessage"}
            style={{
              ...(Styles.messageStack("success") as any),
              display: "flex",
              alignItems: "center",
            }}
          >
            <SkyMessageBar
              intent="success"
              className={successClassName ? successClassName : "successMessage"}
              message={notificationMessage || ""}
            />
            <SkyButton
              onClick={handleClose}
              appearance="transparent"
              icon={X}
              size="small"
            />
          </div>
        </div>
      )}
      {onClose && (
        <div
          id={failureClassName ? failureClassName : "errorMessage"}
          style={{ ...Styles.messageBar, ...styles }}
        >
          <div
            className={failureClassName ? failureClassName : "errorMessage"}
            style={{
              ...(Styles.messageStack("error") as any),
              display: "flex",
              alignItems: "center",
            }}
          >
            <SkyMessageBar
              intent="error"
              className={failureClassName ? failureClassName : "errorMessage"}
              message={notificationMessage || ""}
            />
            <SkyButton
              onClick={handleClose}
              appearance="transparent"
              icon={X}
              size="small"
            />
          </div>
        </div>
      )}

      {onClose && (
        <div
          id={warningClassName ? warningClassName : "warningMessage"}
          style={{ ...Styles.messageBar, ...styles }}
        >
          <div
            className={warningClassName ? warningClassName : "warningMessage"}
            style={{
              ...(Styles.messageStack("warning") as any),
              display: "flex",
              alignItems: "center",
            }}
          >
            <SkyMessageBar
              intent="warning"
              className={warningClassName ? warningClassName : "warningMessage"}
              message={notificationMessage || ""}
            />
            <SkyButton
              onClick={handleClose}
              appearance="transparent"
              icon={X}
              size="small"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SuccessAndErrorMessage;
